import JSX from "../../helpers/react.js";
import {tjs} from "../../lang.js";
import {createElementFromHTML} from "../../helpers/functions.js";
import {SendActionBtns} from "./SendActionBtns.js";
import {EditActionBtns} from "./EditActionBtns.js";
import {BBButtons} from "./BBButtons.js";


export function EditCommentField({isEdit, text}: {isEdit: boolean, text?: string}){
    return (
        <>
            <span className="comment-textarea edit-message bordered" data-placeholder={tjs('comment_placeholder')} contenteditable="true" maxlength="5000">{text?createElementFromHTML(text):false}</span>
                <button className="emojis-btn materiable emojis-comment"><i className="far fa-smile-o"></i></button>
                <div className="comment-menu">
                    <BBButtons/>
                    {
                        isEdit?<EditActionBtns/>:<SendActionBtns/>
                    }
            </div>
        </>
    );
}
function CommentsBlockWithEditField({isEdit, text}: {isEdit: boolean, text?: string}){
    return (
        <div id="comments">
            <div className="leave-comment-body-wrapper comment" style={page_type === 'anime'?{paddingTop: 0}:{}}>
                <EditCommentField isEdit={isEdit} text={text}/>
            </div>
            <UnauthorizedComments/>
        </div>
    );
}
function UnauthorizedComments(){
    return (
        <div>
            <div className="sort-block comments-sort sub-menu-container inline-sub-menu hidden">
                <div className="inline">{tjs('sort_label')}</div>
                <div className="sub-menu-container-icon bordered materiable"><span className="fa fa-bars"></span></div>
                <div className="sub-menu-inner-container bordered-overflow inline">
                    <span className="materiable default-button active sort-comments-btn bordered-overflow" data-by="new">{tjs('sort_new_first')}</span>
                    <span className="materiable default-button sort-comments-btn bordered-overflow" data-by="old">{tjs('sort_old_first')}</span>
                    <span className="materiable default-button sort-comments-btn bordered-overflow" data-by="nice">{tjs('sort_by_rating')}</span>
                </div>
            </div>

            <div className="comments-block"></div>
            <div className="more-comments-container">
                <div className="more-comments main-button bordered">{tjs('load_comments')}</div>
            </div>
        </div>
    );
}
export function CommentsBlock(){
    if(user_id) return <CommentsBlockWithEditField isEdit={false}/>

    return <UnauthorizedComments />
}
